// @ts-nocheck
import React, { useCallback } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from '@mui/material';
import PropTypes from 'prop-types';
import { object, string } from 'yup';
import { useFormik } from 'formik';
import { ReactComponent as CloseIcon } from '../../../assets/Icons/lucideIcons/x.svg';

/**
 * @typedef LinkModalProps
 * @property {(url: string) => void} onSubmit
 * @property {string} [currentURL]
 */

const validationSchema = object({
  url: string(),
});

/**
 * @param {LinkModalProps & import("@mui/material").DialogProps} props
 */
const LinkModal = ({ open, onClose, onSubmit, currentURL = '', ...props }) => {
  const handleSubmit = useCallback(
    (url) => {
      onSubmit(url);
      onClose();
    },
    [onSubmit, onClose]
  );

  const formik = useFormik({
    initialValues: {
      url: currentURL,
    },
    onSubmit: (values) => {
      handleSubmit(values.url);
    },
    enableReinitialize: true,
    validationSchema,
  });

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Dialog open={open} onClose={handleClose} {...props}>
      <DialogTitle>
        <Box component="span" aria-live="polite" aria-atomic="true">
          URL
        </Box>
      </DialogTitle>

      <IconButton
        aria-label="Close dialog"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent dividers>
        <Grid container>
          <Grid size={12}>
            <TextField
              {...formik.getFieldProps('url')}
              name="url"
              label="URL"
              placeholder="Enter URL"
              value={formik.values.url}
              error={Boolean(formik.touched.url && formik.errors.url)}
              helperText={formik.touched.url && formik.errors.url}
              required
              spellCheck={true}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined" title="Cancel">
          Cancel
        </Button>
        <Button variant="contained" title="Save" onClick={formik.handleSubmit}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
LinkModal.propTypes = {
  open: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(['youtube', 'iframe']).isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  currentURL: PropTypes.string,
};

export default LinkModal;
